import React, { PureComponent } from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { withStyles } from '@mui/styles';
import dataProvider from '../../../providers/dataProvider';

const style = {
  field: {
    marginTop: '20px',
  },
  input: {},
};

class ChooseExercisesModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      selected: [],
      list: [],
      selectedCircuit: '',
    };
  }

  componentDidMount() {
    this.getExercise();
  }

  handleChange = (event) => {
    this.setState({ selectedCircuit: event.target.value });
  };

  getExercise = (term = null) => {
    dataProvider('GET_LIST', 'exercise', {
      pagination: { page: 1, perPage: 20 },
      sort: {},
      filter: { q: term },
    }).then((res) => {
      this.setState(() => ({ list: res.data }));
    });
  };

  handleToggle = (value) => () => {
    const { checked, selected } = this.state;
    const currentIndex = checked.indexOf(value.id);
    const newChecked = [...checked];
    const newSelected = [...selected];
    if (currentIndex === -1) {
      newChecked.push(value.id);
      newSelected.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
      newSelected.splice(currentIndex, 1);
    }
    this.setState(() => ({
      checked: newChecked,
      selected: newSelected,
    }));
  };

  handleSearch = (event) => {
    this.getExercise(event.target.value);
  };

  handleAdd = () => {
    this.props.handleAddExercises(this.state.selected, this.state.selectedCircuit);
    this.setState({ selected: [] });
    this.props.handleClose();
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          fullWidth
          maxWidth="md"
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Exercise Library</DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel>Add to circuit</InputLabel>
              <Select fullWidth value={this.state.selectedCircuit} onChange={this.handleChange}>
                <MenuItem value="" />
                {this.props.circuits.map((item, i) => (
                  <MenuItem key={i + +Date.now()} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Filter by name</InputLabel>
              <Input
                className={classes.input}
                fullWidth
                placeholder="Name"
                onChange={this.handleSearch}
              />
            </FormControl>

            {!this.state.list.length ? (
              <p>Exercises are not found</p>
            ) : (
              <List>
                {this.state.list.map((value) => (
                  <ListItem key={value.id} dense button onClick={this.handleToggle(value)}>
                    <Checkbox
                      checked={this.state.checked.indexOf(value.id) !== -1}
                      tabIndex={-1}
                      disableRipple
                    />
                    <ListItemText primary={`${value.name}`} />
                  </ListItem>
                ))}
              </List>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleAdd} color="primary">
              Add exercise
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(style)(ChooseExercisesModal);
